import Api from "../../api.js";

export const getList = async (url) => {
    return (await Api(url))?.data?.list
}
